import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 28526 12931"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0,.str1{stroke:#1c1b17;stroke-width:413.421}.fil0{fill:none}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974604511488">
        <path
          d="M23379 10950H5147c-105 0-273 86-334 170l-1092 1501h21084l-1092-1501c-61-84-229-170-334-170z"
          className="stroke1"
          style={{
            strokeWidth: 413.421,
            fill: "none",
          }}
        />
        <path
          d="M27549 207H977c-423 0-770 347-770 770v10977c0 423 347 770 770 770h1102c-57-154-24-331 94-493l1316-1809c182-250 553-439 862-439h19824c309 0 680 189 862 439l1317 1809c117 162 150 339 93 493h1102c423 0 770-347 770-770V977c0-423-347-770-770-770z"
          className="stroke1"
          style={{
            strokeWidth: 413.421,
            fill: "none",
          }}

        />
        <circle cx={2360} cy={2326} r={620} className="fil1 " />
        <circle cx={4840} cy={2326} r={620} className="fil1 " />
        <circle cx={7320} cy={2326} r={620} className="fil1 " />
        <rect
          width={19578}
          height={476}
          x={4376}
          y={8225}
          className="fil1 "
          rx={8268}
          ry={8268}
        />
        <rect
          width={19578}
          height={476}
          x={4376}
          y={6572}
          className="fil1"
          rx={8268}
          ry={8268}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
